export default __webpack_public_path__ + "static/media/community-rooms.inline.1db3256e.svg";